import React, { Component } from 'react';
import '../styles/Ventajas.css';
import Banner from './Banner'
import ventajaBanner from '../images/ventajas/ventajas-banner.png'
import arrowSelect from '../icons/ventajas/arrow-left-select.svg'
import arrowUnselect from '../icons/ventajas/arrow-left-unselect.svg'
import LoadIndicator from './LoadIndicator'
import ScrollTop from './ScrollTop'
import Analytics from './Analytics'

const independencia = {
    icon: "iconIndependencia",
    text: "firstTextContainer",
    title: "textIndependencia",
    isRight: false,
    dot: "firstDotLeft"   
}
const calidad = {
    icon: "iconCalidad",
    text: "calidadTextContainer",
    title: "textAlin",
    isRight: true,
    dot: "firstDotRight"   
}
const servicio = {
    icon: "iconServicio",
    text: "secondTextContainer",
    title: "textServicio",
    isRight: false,
    dot:"secondDotLeft"
}
const trato = {
    icon: "iconTrato",
    text: "tratoTextContainer",
    title: "textInfo",
    isRight: true,
    dot: "secondDotRight"   
}
const infraestructura = {
    icon: "iconInfraestructura",
    text: "thirdTextContainer",
    title: "textTrato",
    isRight: false,
    dot: "thirdDotLeft"   
}
const certificacion = {
    icon: "iconCertificacion",
    text: "certifTextContainer",
    title: "textCertif",
    isRight: true,
    dot: "fifthDotRight"   
}

class Ventajas extends Component {
    
    closeTextContainer(item){
        let title = document.getElementById(item.title)
        let text = document.getElementById(item.text)
        let dot = document.getElementById(item.dot)
        let image = document.getElementById(item.icon)
        let isRight = item.isRight

        text.style.width = "0%"
        text.style.opacity = ""
        text.style.height= "0px"
        text.style.overflow = "hidden"
        text.style.animation = "unset"

        title.style.color = "#4a4a4a"
        title.classList.remove("selected");

        image.src = arrowUnselect
        title.classList.remove("selected");
        dot.style.display = "none"
        if(isRight){
            image.style.transform = "rotate(0deg)"
        }
        else{
            image.style.transform = "rotate(180deg)"
        }
    }
    openTextContainer(item){
        let title = document.getElementById(item.title)
        let text = document.getElementById(item.text)
        let dot = document.getElementById(item.dot)
        let image = document.getElementById(item.icon)
        let isRight = item.isRight

        text.style.animation = "reveal 1s"
        text.style.display = "inline-block"
        text.style.width = "25%"
        text.style.opacity = "1"
        text.style.height= "250px"

        title.style.color = "#ff8400"

        image.src = arrowSelect
        title.classList.add("selected");
        dot.style.display = "block"
        if(isRight){
            image.style.transform = "rotate(180deg)"
        }else{
            image.style.transform = "rotate(0deg)"
        }
    }
    showText = (item, sideItem) =>{
        let title = document.getElementById(item.title)
        if(title.classList.contains("selected")){
            this.closeTextContainer(item)
        }else{
            this.closeTextContainer(sideItem)
            this.openTextContainer(item)
        }
    }
    showTextMobile = (e, idText, idTitle, idLoadDot) =>{
        let title = document.getElementById(idTitle)
        let text = document.getElementById(idText)
        let dot = document.getElementById(idLoadDot)
        let image = e.target
        if(title.classList.contains("selected")){
            text.style.display = "none"

            title.style.color = "#4a4a4a"
            title.classList.remove("selected");

            image.src = arrowUnselect
            title.classList.remove("selected");
            dot.style.display = "none"
            image.style.transform = "rotate(-90deg)"
            
        }else{
            text.style.display = "block"

            title.style.color = "#ff8400"

            image.src = arrowSelect
            title.classList.add("selected");
            dot.style.display = "block"
            
            image.style.transform = "rotate(90deg)"
        }
    }
    render(){
        return (
            <div className="Ventajas">
                <ScrollTop />
                <Analytics />
                <div class="ventajas-container">
                    <Banner imageBanner={ventajaBanner} className="ventaja-banner" title="Ventajas" description="¿Por qué nuestros clientes nos eligen?"/>
                    <div class="ventajas-description">
                        <h1>INNOVACIÓN CONTINUA</h1>
                        <p>Nos eligen porque estamos constantemente innovado e invirtiendo para mejorar nuestro servicio y ser los número uno del mercado.</p>
                    </div>
                    <div class="ejemplo-container"> 
                        <div class="div-ejemplo title title-left" id="textIndependencia">
                            <p class="">Independencia</p>
                        </div>
                        <div class="div-ejemplo first">
                            <img src={arrowUnselect} id="iconIndependencia" class="arrow-right" onClick={() => this.showText(independencia, calidad)}/>
                            <div class="loading-ventaja" id="firstDotLeft">
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                            </div>
                        </div> 
                        <div class="div-ejemplo second" id="firstTextContainer"> 
                            <p>Porque cada uno de los Laboratorios que trabaja con nosotros lo hace con absoluta independencia.</p>   
                        </div>
                        <div class="div-ejemplo second" id="calidadTextContainer"> 
                            <p>Un perfil multinacional con fortaleza económica y acciones comerciales acorde al nivel de los socios. Prácticas alineadas con las políticas de los socios.</p>   
                        </div>
                        <div class="div-ejemplo first" >
                            <div class="loading-right" id="firstDotRight">
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                            </div>
                            <img src={arrowUnselect} id="iconCalidad" onClick={() => this.showText(calidad, independencia)}/>
                        </div> 
                        <div class="div-ejemplo title title-right" id="textAlin">
                            <p class="">Calidad de los accionistas</p>
                        </div>
                    </div>

                    <div class="ejemplo-container"> 
                        <div class="div-ejemplo title title-left" id="textServicio">
                            <p class="">Servicios a medida</p>
                        </div>
                        <div class="div-ejemplo first">
                            <img src={arrowUnselect} id="iconServicio" class="arrow-right" onClick={() => this.showText(servicio, trato)} />
                            <div class="loading-ventaja" id="secondDotLeft">
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                            </div>
                        </div> 
                        <div class="div-ejemplo second" id="secondTextContainer"> 
                            <p>Diseñamos el servicio a medida de cada operación comercial que necesita su negocio. Facturación por laboratorio. Absoluto control de condiciones comerciales y límites de crédito previo a la facturación. </p>   
                        </div>
                        <div class="div-ejemplo second" id="tratoTextContainer"> 
                            <p>Trato igualitario a todos los laboratorios. Búsqueda constante de consenso entre los participantes sin acciones corporativas.</p>   
                        </div>
                        <div class="div-ejemplo first">
                            <div class="loading-right" id="secondDotRight">
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                            </div>
                            <img src={arrowUnselect} id="iconTrato" onClick={() => this.showText(trato, servicio)}/>
                        </div> 
                        <div class="div-ejemplo title title-right" id="textInfo">
                            <p class="">Trato igualitario a todos los laboratorios.</p>
                        </div>
                    </div>

                    <div class="ejemplo-container"> 
                        <div class="div-ejemplo title title-left" id="textTrato">
                            <p class="">Infraestructura</p>
                        </div>
                        <div class="div-ejemplo first">
                            <img src={arrowUnselect} id="iconInfraestructura" class="arrow-right" onClick={() => this.showText(infraestructura, certificacion)}/>
                            <div class="loading-ventaja" id="thirdDotLeft">
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                            </div>
                        </div> 
                        <div class="div-ejemplo second" id="thirdTextContainer"> 
                            <p>Depósito de 14.000 mts2 con temperatura y humedad controlada en un 100%. Equipamiento tecnológico de última generación. Plan de continuidad de negocio auditado. Data center duplicado</p>   
                        </div>
                        <div class="div-ejemplo second" id="certifTextContainer"> 
                            <p>Certificación iso 9001. V2015. ISAE 3402 SOX. FCPA (prácticas anti-corrupción). Sistema validado GAMP V</p>
                        </div>
                        <div class="div-ejemplo first">
                        <div class="loading-right" id="fifthDotRight">
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                                <div class="loading-dot-ventaja"></div>
                            </div>
                            <img src={arrowUnselect} id="iconCertificacion" onClick={() => this.showText(certificacion, infraestructura)}/>
                        </div> 
                        <div class="div-ejemplo title title-right" id="textCertif">
                            <p class="">Certificaciones</p>
                        </div>
                    </div>
                </div>
                <div class="ejemplo-container-mobile">
                    <div>
                        <h3 id="firstTitleMobile">Independencia</h3>
                        <p id="indpText">Porque cada uno de los Laboratorios que trabaja con nosotros lo hace con absoluta independencia.</p>
                        <div class="load-indicator-container" id="firstLoadIndicator">
                            <LoadIndicator />
                        </div>
                        <img src={arrowUnselect} class="arrow-ventaja-mobile" onClick={(e) => this.showTextMobile(e,"indpText", "firstTitleMobile", "firstLoadIndicator")}/>
                    </div>
                    <div>
                        <h3 id="calidTitle">Calidad de los accionistas</h3>
                        <p id="calidText">Un perfil multinacional con fortaleza económica y acciones comerciales acorde al nivel de los socios. Prácticas alineadas con las políticas de los socios.</p>
                        <div class="load-indicator-container" id="calidLoadIndicator">
                            <LoadIndicator />
                        </div>
                        <img src={arrowUnselect} class="arrow-ventaja-mobile" onClick={(e) => this.showTextMobile(e,"calidText", "calidTitle", "calidLoadIndicator")} />
                    </div>
                    <div>
                        <h3 id="servTitle">Servicios a medida</h3>
                        <p id="servText">Diseñamos el servicio a medida de cada operación comercial que necesita su negocio. Facturación por laboratorio. Absoluto control de condiciones comerciales y límites de crédito previo a la facturación. </p>
                        <div class="load-indicator-container" id="servLoadIndicator">
                            <LoadIndicator />
                        </div>
                        <img src={arrowUnselect} class="arrow-ventaja-mobile" onClick={(e) => this.showTextMobile(e,"servText", "servTitle", "servLoadIndicator")} />
                    </div>
                    <div>
                        <h3 id="tratoTitle">Trato igualitario a todos los laboratorios.</h3>
                        <p id="tratoText">Trato igualitario a todos los laboratorios. Búsqueda constante de consenso entre los participantes sin acciones corporativas.</p>
                        <div class="load-indicator-container" id="tratoLoadIndicator">
                            <LoadIndicator />
                        </div>
                        <img src={arrowUnselect} class="arrow-ventaja-mobile" onClick={(e) => this.showTextMobile(e,"tratoText", "tratoTitle", "tratoLoadIndicator")} />
                    </div>
                    <div>
                        <h3 id="analisisTitle">Infraestructura</h3>
                        <p id="analisisText">Depósito de 14.000 mts2 con temperatura y humedad controlada en un 100%. Equipamiento tecnológico de última generación. Plan de continuidad de negocio auditado. Data center duplicado</p>
                        <div class="load-indicator-container" id="analisisLoadIndicator">
                            <LoadIndicator />
                        </div>
                        <img src={arrowUnselect} class="arrow-ventaja-mobile" onClick={(e) => this.showTextMobile(e,"analisisText", "analisisTitle", "analisisLoadIndicator")} />
                    </div>
                   
                    <div>
                        <h3 id="certifTitle">Certificaciones</h3>
                        <p id="certifText">Certificación iso 9001. V2015. ISAE 3402 SOX. FCPA (prácticas anti-corrupción). Sistema validado GAMP V</p>
                        <div class="load-indicator-container" id="certifLoadIndicator">
                            <LoadIndicator />
                        </div>
                        <img src={arrowUnselect} class="arrow-ventaja-mobile" onClick={(e) => this.showTextMobile(e,"certifText", "certifTitle", "certifLoadIndicator")} />
                    </div>
                </div>
            </div>
        );
    }
}

export default Ventajas;


// WEBPACK FOOTER //
// ./src/components/Ventajas.js